import React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";

import { LiaSearchSolid } from "react-icons/lia";

const SearchBtn = () => {
  return (
    <OutlinedInput
      placeholder="Suche"
      startAdornment={
        <InputAdornment position="start">
          <LiaSearchSolid color="#CD9D41" size={26} />
        </InputAdornment>
      }
      sx={{
        gap: 2,
        width: {md:"60%",xs:"70%"},
        height: "75%",
        borderRadius: "12px",
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#CD9D41", 
        },
      }}
    />
  );
};

export default SearchBtn; 